import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import { DataGrid } from '@mui/x-data-grid';

import { fetchCompletedJobs } from './action';
import { selectCompletedJobs, selectUpdateJobError } from './selector';

const CompletedJobList = () => {
  const dispatch = useDispatch();
  const completedJobs = useSelector(selectCompletedJobs);
  const updateJobError = useSelector(selectUpdateJobError);

  const isPetOwner =
    localStorage.getItem('isPetOwner') ?
      JSON.parse(localStorage.getItem('isPetOwner')) :
      true;

  useEffect(() => {
    dispatch(fetchCompletedJobs(isPetOwner));
  }, [dispatch, isPetOwner]);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const columns = [
    { field: '_id', sortable: false, headerName: 'Job ID', width: 220 },
    {
      field: isPetOwner ? 'selectedSitterId' : 'creatorId',
      headerName: isPetOwner ? 'Sitter ID' : 'Owner ID',
      width: 220,
    },
    {
      field: 'createdAt',
      headerName: 'Created on',
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString('en-US');
      }
    },
    {
      field: 'petName',
      headerName: 'Pet Name',
      width: 150,
      valueGetter: (params) => params.row.jobDetails.petName,
    },
    {
      field: 'petType',
      headerName: 'Pet Type',
      width: 150,
      valueGetter: (params) => {
        const { petType } = params.row.jobDetails;
        return petTypes.find(pet => pet.value === petType)?.label;
      },
    },
  ];

  return (
    <Container component="main" maxWidth="lg" sx={{ pt: 6 }}>
        <Card sx={{ padding: "2rem" }}>
      <Typography variant="h5" component="h1">
        Total Completed Jobs: {completedJobs.length}
      </Typography>
      {updateJobError && (
        <Alert severity="error" sx={{ mt: 1 }}>{updateJobError}</Alert>
      )}
      <div
        style={{
          height: 80 * completedJobs.length + 200,
          width: '100%',
          marginTop: 20,
        }}
      >
        <DataGrid
          rows={completedJobs}
          columns={columns}
          getRowId={row => row._id}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </div>
      </Card>
    </Container>
  );
};

export default CompletedJobList;
